export default {
    install (Vue) {
      Vue.prototype.$format = {
        cloneVariable (data) {
					if (!data) return null
					return JSON.parse(JSON.stringify(data))
				}
      }
    }
}